import React from 'react';
import ContentLoader from 'react-content-loader';

const DetailsLoader = ({ rows, showHeader = false, leftColumnWidth = 120 }) => {
	const height = 20;
	const rowHeight = 30;
	const borderRadius = 2;

	const rowArray = [];

	const random = () => Math.floor(Math.random() * 60) + 40;

	const headerLoader = () => (
		<>
			<rect x="0" y="0" rx="2" ry="2" width="80" height="20" />
			<rect x="85" y="20" rx="1" ry="1" width="170" height="1" />
			<rect x="260" y="0" rx="2" ry="2" width="60" height="20" />
		</>
	);

	// Convert number of rows to array so it can be mapped
	for (let i = 0; i < rows; i++) {
		rowArray.push(i + 1);
	}

	return (
		<ContentLoader
			backgroundColor="#f2f2f2"
			foregroundColor="#e2e2e2"
			speed={4}
		>
			{rowArray.map(row => {
				const leftWidth = random();

				return (
					<React.Fragment key={row}>
						{showHeader && headerLoader()}
						<rect
							x={leftColumnWidth - leftWidth}
							y={rowHeight * row}
							rx={borderRadius}
							ry={borderRadius}
							width={leftWidth}
							height={height}
						/>
						<rect
							x={leftColumnWidth + 20}
							y={rowHeight * row}
							rx={borderRadius}
							ry={borderRadius}
							width={random()}
							height={height}
						/>
					</React.Fragment>
				);
			})}
		</ContentLoader>
	);
};

export default DetailsLoader;
